import type { ServiceClassesTranslationMessages } from './serviceClassesTranslationMessages';

export const serviceClassesLanguageItalian: ServiceClassesTranslationMessages = {
  service_classes: {
    name: 'Classi di Servizio',
    fields: {
      id: 'ID',
      name: 'Nome',
      is_default: 'Default',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      office_hours: {
        start_time: 'Ora inizio',
        end_time: 'Ora fine',
        weekday: 'Giorno della settimana',
        weekdays: {
          mo: 'Lunedì',
          tu: 'Martedì',
          we: 'Mercoledì',
          th: 'Giovedì',
          fr: 'Venerdì',
          sa: 'Sabato',
          su: 'Domenica',
        },
      },
      password_policy: {
        history: 'Dimensione storico password',
        lowercase: 'Numero minimo caratteri minuscoli',
        max_length: 'Lunghezza massima',
        min_length: 'Lunghezza minima',
        numbers: 'Numero minimo di cifre',
        special: 'Numero minimo di carateri speciali',
        uppercase: 'Numero minimo di caratteri maiuscoli',
      },
      sip_password_policy: {
        history: 'Dimensione storico password',
        lowercase: 'Numero minimo caratteri minuscoli',
        max_length: 'Lunghezza massima',
        min_length: 'Lunghezza minima',
        numbers: 'Numero minimo di cifre',
        special: 'Numero minimo di carateri speciali',
        uppercase: 'Numero minimo di caratteri maiuscoli',
      },
      users_policy: {
        account_disable_when_idle: 'Disabilita account per inattività',
        account_expires: 'Disabilita account',
        enforce_mfa: "Forza l'utilizzo di autenticazione a due fattori",
        password_expires: 'Scadenza password',
      },
    },
    operations: {
      create: 'Crea classe di servizio',
      delete: 'Elimina classe di sevizio',
      edit: 'Modifica classe di servizio',
      sections: {
        password_policy: 'Password utente',
        sip_password_policy: 'Password SIP',
        users_policy: 'Politiche Utente',
        details: 'Dettagli',
        office_hours: 'Orari d’ufficio',
      },
    },
    helperTexts: {
      users_policy: {
        password_expires: 'Validità della password in giorni',
        account_disable_when_idle:
          'Numero di giorni dopo i quali un utente inattivo sarà automaticamente disabilitato. Un valore pari a zero significa che il controllo non sarà abilitato',
        account_expires: "Numero di giorni di validità dell'account",
        enforce_mfa: 'Se abilitato sarà permesso il login di utenti solo con autenticazione a due fattori',
      },
      password_policy: {
        history:
          "Lunghezza della cronologia delle password. Le password già utilizzate l'ultima volta nella cronologia non saranno accettate nelle operazioni di modifica della password/aggiornamento dell'utente",
      },
    },
    errors: {
      password_policy: {
        minLength: 'La password deve essere lunga almeno %{minLength} caratteri',
        maxLength: 'La password deve essere lunga al massimo %{maxLength} caratteri',
        minUppercase: 'La password deve contenere almeno %{minUppercase} lettere maiuscole',
        minLowercase: 'La password deve contenere almeno %{minLowercase} lettere minuscole',
        minNumbers: 'La password deve contenere almeno %{minNumbers} numeri',
        minSpecials: 'La password deve contenere almeno %{minSpecials} caratteri speciali',
      },
    },
  },
};
